<template>
<div>
  <div v-if="currentIndex>0" class="pl1x bdSub-bottom-notLast">
    <div class="tabBar style-tabBar cb active-c-main_E tra-fast_E navpadding">
      <button v-permissions="'B/A/A3'" permission-type="none" class="cSub afterButton"
              :class="{active:1==currentIndex}"
              @click="changeBtn(1)">{{getLanguageStr("word1661","控制日志")}}</button>
      <button v-permissions="'B/A/A4'" permission-type="none" class="cSub afterButton"
              :class="{active:2==currentIndex}"
              @click="changeBtn(2)">{{getLanguageStr("word1662","升级日志")}}</button>
    </div>
  </div>
  <div class="pl1x pt1x pr1x pb1x" fillheight="lastHeight">
    <ReaderRecord v-if="currentIndex ==1"
                  :timezone="timezone"
                  :deviceId="deviceId"
                  :deviceSn="deviceSn"
                  ref="ReaderRecord"></ReaderRecord>
    <UpdateRecord v-if="currentIndex ==2"
                  :timezone="timezone"
                  :deviceId="deviceId"
                  :deviceSn="deviceSn"
                  ref="UpdateRecord"></UpdateRecord>
    <NoData v-if="currentIndex==-1"></NoData>
  </div>
</div>
</template>
<script>
import { getLanguageStr } from '@/util/language'
import * as lib from '@/util/lib.js'
import StatusIco from '@/components/common/ui/StatusIco.vue';
import NoData from '@/components/common/ui/NoResult.vue';

import ReaderRecord from '@/view/device/device/part/ReaderRecord'// 控制记录
import UpdateRecord from '@/view/device/device/part/UpdateRecord'// 升级记录
export default {
  name: 'oprateRecord',
  components: { StatusIco,NoData,ReaderRecord, UpdateRecord },
  props: {
    deviceId: {
      type: [String, Number],
      default: null
    },
    deviceSn: {
      type: [String, Number],
      default: null
    },
    timezone: {
      type: String,
      default: 'PRC'
    },
    tabindex: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      tabList:[//tab列表
        {
          status:lib.doPermissions("B/A/A3"),
          index:1
        },
        {
          status:lib.doPermissions("B/A/A4"),
          index:2
        }
      ],
      currentIndex:-1
    }
  },
  created:function(){
    let onList=[];
    $.each(this.tabList,(index,val)=>{//处理可用tab
      if(this.tabindex==val.index&&val.status) this.currentIndex=val.index;//优先指定
      if(val.status) onList.push(val.index);//登记可用tab
    });
    if(onList.length&&this.currentIndex<0) this.currentIndex=onList[0];//没有指定且有可用
  },
  methods: {
    timeFormat: lib.timeFormat,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    changeBtn (index) {
      this.currentIndex=index;
      this.$nextTick(_ => {
        this.currentIndex === 1 && this.$refs.ReaderRecord.show(1)
        this.currentIndex === 2 && this.$refs.UpdateRecord.show(2)
      })
    },
    show () {
      this.changeBtn(this.currentIndex);
    }
  },
  mounted () {
    this.$nextTick(_ => {
      // this.changeBtn(this.currentIndex);
      lib.fillHeight();
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/view/device/device/part/OperateRecord.vue